import { Injectable } from '@angular/core';

interface PendingRequest {
    id: string;
    type: 'UPDATE_STOCKS' | 'UPDATE_QUANTITY';
    data: any;
    timestamp: number;
}

@Injectable({ providedIn: 'root' })
export class OfflineSyncService {
    private readonly STORAGE_KEY = 'pending_inventory_updates';

    constructor() {}

    /**
     * Store a request for later retry
     */
    queueRequest(type: 'UPDATE_STOCKS' | 'UPDATE_QUANTITY', data: any) {
        const pending = this.getPendingRequests();
        const newRequest: PendingRequest = {
            id: Math.random().toString(36).substring(2, 9),
            type,
            data,
            timestamp: Date.now()
        };
        pending.push(newRequest);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(pending));
        return newRequest.id;
    }

    /**
     * Remove a request from the queue after successful retry
     */
    removeRequest(id: string) {
        const pending = this.getPendingRequests();
        const filtered = pending.filter(r => r.id !== id);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(filtered));
    }

    /**
     * Get all pending requests
     */
    getPendingRequests(): PendingRequest[] {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        try {
            return stored ? JSON.parse(stored) : [];
        } catch (e) {
            console.error('Error parsing pending requests', e);
            return [];
        }
    }

    /**
     * Check if there are any pending requests
     */
    hasPendingRequests(): boolean {
        return this.getPendingRequests().length > 0;
    }
}
